import { render, staticRenderFns } from "./FileViewerSection.vue?vue&type=template&id=6742e01d&scoped=true&"
import script from "./FileViewerSection.vue?vue&type=script&lang=js&"
export * from "./FileViewerSection.vue?vue&type=script&lang=js&"
import style0 from "./FileViewerSection.vue?vue&type=style&index=0&id=6742e01d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6742e01d",
  null
  
)

export default component.exports